module.exports = __webpack_public_path__ + "static/img/bundesheer-kooperationspartner.de413fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/bundesheer-kooperationspartner.png
// module id = s3dx
// module chunks = 0